import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import InputBase from './InputBase';
import { Calendar } from '../../../assets/images/svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const onChange = (value, props) => {
  if (props) return props.handleChange(value, props);
};
/*
const Input = ({ innerRef }) => {
  return (
    <div>
      <input ref={innerRef} />
    </div>
  )
}
*/
const customDateInput = (disabled, errors, label, cssClass) => {
  const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <InputBase disabled={disabled} errors={errors} type="date-picker" value={value} size="lg" name="date" label={label} onClick={onClick} cssClass={cssClass} endAdornment={<Calendar />} ref={ref} />
  ));

  return <CustomDateInput />;
};

const CustomDateInput = (inputProps) => {
  const { value, disabled, errors, label, minDate, maxDate, cssClass, openToDate } = inputProps;
  
  return (
    <DatePicker
      disabled={disabled}
      customInput={customDateInput(disabled, errors, label, cssClass)}
      dateFormat="MMM dd, yyyy"
      closeOnScroll
      showYearDropdown
      fixedHeight
      adjustDateOnChange
      showPopperArrow={false}
      selected={value}
      onChange={(value) => onChange(value, inputProps)}
      minDate={minDate}
      maxDate={maxDate}
      openToDate={openToDate}
    />
  );
};

CustomDateInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  errors: PropTypes.string,
  disabled: PropTypes.bool,
  endAdornment: PropTypes.string,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
};

export default CustomDateInput;
